import React, { Component } from 'react';

export default class TabContent extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.index);
    }

    render() {
        let content;

        if(this.props.url) {
            content = (
                <figure className="tabs-component__content-figure">
                    <img className="tabs-component__content-image" src={this.props.url}
                         alt={this.props.alt ? this.props.alt : this.props.title} />
                </figure>
            );
        }

        return (
            <div className={"tabs-component__content-item "
                + (this.props.isActive ? "active " : " ")
                + (this.props.url ? "tabs-component__content-item--image" : "")}
                 onClick={this.handleClick} id={"tabcontent-id-" + this.props.index} role="tabpanel"
                 aria-labelledby={"tab-button-id-" + this.props.index} aria-hidden={!this.props.isActive}>
                {content}
            </div>
        );
    }
}